var exports = {
  "kL": "GroupedVoiceParticipant.module__container___SWdyOU",
  "AG": "GroupedVoiceParticipant.module__participantButton___SWdyOU",
  "IT": "GroupedVoiceParticipant.module__participantButtonSpeaking___SWdyOU",
  "O": "GroupedVoiceParticipant.module__participantButtonContextMenuActive___SWdyOU",
  "SX": "GroupedVoiceParticipant.module__avatarAndName___SWdyOU",
  "VW": "GroupedVoiceParticipant.module__nameContainer___SWdyOU",
  "F8": "GroupedVoiceParticipant.module__participantName___SWdyOU",
  "xr": "GroupedVoiceParticipant.module__participantNameSpeaking___SWdyOU",
  "S$": "GroupedVoiceParticipant.module__participantNameCurrent___SWdyOU",
  "u$": "GroupedVoiceParticipant.module__deviceCountButton___SWdyOU",
  "g0": "GroupedVoiceParticipant.module__iconsAndToggle___SWdyOU",
  "pP": "GroupedVoiceParticipant.module__devicesContainer___SWdyOU",
  "nt": "GroupedVoiceParticipant.module__flexShrinkZero___SWdyOU",
};

module.exports = exports;
